<app-common-header></app-common-header>
<main role="main" class="maincntq">
  <input
    type="hidden"
    id="autoPayCCTPAT"
    name="autoPayCCTPAT"
    [(ngModel)]="autoPayCCTPAT"
  />
  <input
    type="hidden"
    id="depositCCTPAT"
    name="depositCCTPAT"
    [(ngModel)]="depositCCTPAT"
  />
  <div class="getbannersect sectppad pb-2">
    <div class="sectpad container-fluid">
      <div class="col-12 text-center webview">
        <img src="assets/images/signimg.jpg" class="signimg signimgg" />
      </div>
      <div class="col-sm-12 p-0 webview" [@flyInOut]="'in'">
        <div class="card-wrapper m-auto">
          <div class="col-md-12 mt-5">
            <h1
              class="text-center ssnHeadTxt"
              [innerHTML]="setDepositTitleValue()"
            ></h1>

            <div class="col-md-11 m-auto">
              <div *ngIf="!autoPay4CE" class="">
                <span class="ssnTxt d-inline-block mt-3"
                  >Due to your credit and as a favor so that you don’t miss a
                  payment and have to deal with annoying late fees and possible
                  disconnect / reconnect fees etc, 4Change Energy is asking that
                  you post a ${{ depositAmount4CE }} deposit and signup for
                  autopay in order to proceed signing up for this plan. </span
                ><br />
                <span class="ssnTxt d-inline-block mt-3">
                  To not miss out on this offer and get your service request
                  processed today, please click the button below.
                </span>
                <span class="ssnTxt d-inline-block mt-3 mb-3"
                  ><strong
                    style="
                      font-size: 19px !important;
                      font-family: 'Calibre-SemiBold';
                    "
                    >Important Note:</strong
                  >
                  If you choose to pay the deposit, it will be returned to you
                  with interest either after one year as a
                  customer-in-good-standing with 4Change Energy, or if you
                  move-out of your location before your contract expires. Please
                  see your Terms of Service for 4Change Energy’s Deposit Policy.
                </span>
              </div>
              <div *ngIf="autoPay4CE" class="">
                <span class="ssnTxt d-inline-block mt-3"
                  >Due to your credit and as a favor so that you don’t miss a
                  payment and have to deal with annoying late fees and possible
                  disconnect / reconnect fees etc, 4Change Energy is asking that
                  you signup for autopay in order to proceed signing up for this
                  plan.
                </span>
                <span class="ssnTxt d-inline-block mt-3 mb-3"
                  ><strong
                    style="
                      font-size: 19px !important;
                      font-family: 'Calibre-SemiBold';
                    "
                    >IMPORTANT:</strong
                  >
                  Choosing to waive your deposit may impact the service start
                  date that you had previously requested due to amount of time
                  it takes to process and validate.
                </span>
              </div>

              <div class="col-md-11 m-auto text-left">
                <label
                  class="custom-control custom-checkbox chkbox mb-2 box-shadow"
                  for="payfordeposit"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input mgntp10"
                    id="payfordeposit"
                    value="payDeposit"
                    name="payfordeposit"
                    (click)="onChangeRole($event)"
                  />
                  <label
                    class="custom-control-label font16 ml-2"
                    for="payfordeposit"
                    style="
                      color: black !important;
                      font-weight: normal !important;
                    "
                    >{{ setDepositLabelValue() }}</label
                  >
                </label>
                <label
                  class="custom-control custom-checkbox chkbox mb-2 box-shadow"
                  for="applyAnotherProvider"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input mgntp10"
                    id="applyAnotherProvider"
                    value="Applyforadepositwaiver"
                    name="applyAnotherProvider"
                    (click)="onChangeApplyAnotherProvider($event)"
                  />
                  <label
                    class="custom-control-label font16 ml-2"
                    for="applyAnotherProvider"
                    style="
                      color: black !important;
                      font-weight: normal !important;text-align:left;
                      line-height: 1.2;
                    "
                    >Get started with prepaid electricity 
                    for just $19.99. No deposit required</label
                  >
                </label>
              </div>

              <div
                class="col-md-12 ng-tns-c2-0 ng-star-inserted"
                *ngIf="isChecked"
              >
                <div class="col-md-12 px-0">
                  <div class="row font19-weight-semibold-calibre">
                    {{ setCardTextAutoPayBased() }}
                  </div>
                  <br />
                  <div
                    class="card-wrapper-deposit"
                    data-jp-card-initialized="true"
                  >
                    <div class="jp-card-container" style="transform: scale(1)">
                      <div id="jp-card-details" class="jp-card">
                        <div class="jp-card-front">
                          <div class="jp-card-logo jp-card-elo">
                            <div class="e">e</div>
                            <div class="l">l</div>
                            <div class="o">o</div>
                          </div>
                          <div class="jp-card-logo jp-card-visa" *ngIf="isVisa">
                            Visa
                          </div>
                          <div class="jp-card-logo jp-card-visaelectron">
                            Visa
                            <div class="elec">Electron</div>
                          </div>
                          <div class="jp-card-logo jp-card-mastercard">
                            Mastercard
                          </div>
                          <div class="jp-card-logo jp-card-maestro">
                            Maestro
                          </div>
                          <div class="jp-card-logo jp-card-amex"></div>
                          <div class="jp-card-logo jp-card-discover">
                            discover
                          </div>
                          <div class="jp-card-logo jp-card-unionpay">
                            UnionPay
                          </div>
                          <div class="jp-card-logo jp-card-dinersclub"></div>
                          <div class="jp-card-logo jp-card-hipercard">
                            Hipercard
                          </div>
                          <div class="jp-card-logo jp-card-troy">troy</div>
                          <div class="jp-card-logo jp-card-dankort">
                            <div class="dk">
                              <div class="d"></div>
                              <div class="k"></div>
                            </div>
                          </div>
                          <div class="jp-card-logo jp-card-jcb">
                            <div class="j">J</div>
                            <div class="c">C</div>
                            <div class="b">B</div>
                          </div>
                          <div class="jp-card-lower">
                            <div class="jp-card-shiny"></div>
                            <div class="jp-card-cvc jp-card-display">•••</div>
                            <div class="jp-card-number jp-card-display">
                              {{ validateCardDisplay('auto') }}
                            </div>
                            <div class="jp-card-name jp-card-display">
                              {{ validateFullName('auto') }}
                            </div>
                            <div
                              class="jp-card-expiry jp-card-display"
                              data-before="mm/yy"
                              data-after="validdate"
                            >
                              {{ month }}/{{ year }}
                            </div>
                          </div>
                        </div>
                        <div class="jp-card-back">
                          <div class="jp-card-bar"></div>
                          <div class="jp-card-cvc jp-card-display">
                            {{ validateSecurityCode('auto') }}
                          </div>
                          <div class="jp-card-shiny"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-md-7 px-0" id="cdNum">
                      <input
                        class="form-control"
                        type="text"
                        id="txtCardNumber"
                        [maxlength]="maxLength"
                        placeholder="Credit Card Number"
                        (change)="validateCreditCardNumber('auto')"
                        (keyup)="onChangeTxtCardNumber($event)"
                        (keypress)="numberOnly($event)"
                        [(ngModel)]="formattedCardNumber"
                      />
                    </div>
                    <div class="col-md-5">
                      <img
                        style="width: 130px; height: auto !important"
                        class="mt-1"
                        src="/assets/images/cc-cards-images1.png"
                      />
                    </div>

                    <div
                      *ngIf="validCard && formattedCardNumber.length > 10"
                      class="col-sm-12 px-0"
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        That card number did not work. Try again using Visa,
                        MasterCard, Discover or American Express
                      </div>
                    </div>
                    <div
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes('DepositCreditCard Number')
                      "
                      class="col-sm-12 px-0"
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        That card number did not work. Please try re-entering it
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5 px-0">
                      <div class="col-sm-12 px-0 mt-2">
                        <label class="font19-weight-semibold-calibre"
                          >Expiration Date*</label
                        >
                      </div>
                      <div class="col-md-12 d-flex px-0">
                        <div class="mm-yy mr-3">
                          <ng-select
                            [items]="monthList"
                            bindLabel="Text"
                            bindValue="Value"
                            placeholder="MM"
                            [searchable]="true"
                            [clearable]="false"
                            id="cmonth"
                            name="month"
                            [(ngModel)]="month"
                            (change)="validateMonth()"
                            style="width: 110px"
                          >
                          </ng-select>
                        </div>
                        <div class="mm-yy">
                          <ng-select
                            [items]="yearsList"
                            bindLabel="Text"
                            bindValue="Value"
                            placeholder="YYYY"
                            [searchable]="true"
                            [clearable]="false"
                            name="year"
                            id="cyear"
                            [(ngModel)]="year"
                            (change)="validateYear()"
                            style="width: 110px"
                          >
                          </ng-select>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-4 px-0">
                      <div class="col-sm-12 mt-2 pr-0">
                        <label class="font19-weight-semibold-calibre"
                          >Security Code*</label
                        >
                      </div>
                      <div class="col-sm-11" style="padding-left: 75px">
                        <input
                          class="form-control"
                          numbersOnly
                          [(ngModel)]="secuiritycode"
                          type="text"
                          (change)="validatecvv($event, 'auto')"
                          (keyup)="
                            flipCardForSecurityCode($event.target.value, 'auto')
                          "
                          id="ccode"
                          name="secuiritycode"
                          placeholder="CVV"
                          maxlength="4"
                          size="4"
                          required="true"
                          style="width: 64px; height: 38px"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="ml-3"
                        *ngIf="blankmontherr"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Please provide the Expiration Month (MM)
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="blankyearerr"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Please provide the Expiration Year (YYYY)
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="showmontherr || yearErrorFlag"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          {{ errorMessage }}
                        </div>
                      </div>
                      <div
                        *ngIf="
                          postResponseMessage &&
                          (postResponseMessage.includes(
                            'DepositCreditCardYear'
                          ) ||
                            postResponseMessage.includes(
                              'DepositCreditCardMonth'
                            ))
                        "
                        class="ml-3"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          {{ errorMessage }}
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="cvvValid"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Security code is invalid. Please verify and try again.
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes(
                            'DepositCreditCard CVV/CID'
                          )
                        "
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Security code is invalid. Please verify and try again.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mt-2 px-0">
                      <label class="font19-weight-semibold-calibre"
                        >Name as it appears on card*</label
                      >
                    </div>
                    <div class="col-sm-10 pl-0">
                      <input
                        type="text"
                        IsAlphaNumeric
                        class="form-control"
                        (change)="validateccName($event)"
                        (keyup)="flipCardFront('auto')"
                        [(ngModel)]="cardName"
                        id="cardname"
                        name="cardname"
                        placeholder="First and last name"
                        required="true"
                        style="width: 325px !important; height: 38px !important"
                      />
                    </div>
                    <div
                      class="col-sm-12 px-0"
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes(
                          'Required Deposit card billing Info'
                        )
                      "
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        Required information is missing. Please verify your
                        details and try again.
                      </div>
                    </div>
                    <div
                      class="col-sm-12 px-0"
                      *ngIf="checkCardName"
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        Please provide your First and Last Name
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mt-2 px-0">
                      <label class="font19-weight-semibold-calibre"
                        >Billing Address*</label
                      >
                    </div>
                    <br />
                    <div class="col-sm-12 d-flex px-0">
                      <div class="col-sm-10 pl-0 mb-2">
                        <input
                          type="text"
                          id="street_address"
                          [(ngModel)]="street_address"
                          class="form-control"
                          (ngModelChange)="validate()"
                          placeholder="Street Address"
                        />
                      </div>
                      <div class="col-sm-2 mb-2 px-0">
                        <div>
                          <input
                            type="text"
                            id="apt"
                            [(ngModel)]="apt"
                            class="form-control"
                            (ngModelChange)="validate()"
                            placeholder="Apt"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-12 px-0 alertMsg"
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes(
                          'BillingAddress has reached its character limit'
                        )
                      "
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                        margin-top: -3px !important;
                      "
                    >
                      Please enter a valid Billing Address
                    </div>
                    <div
                      class="col-md-12 px-0 alertMsg"
                      *ngIf="street_addressisNull"
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                        margin-top: -3px !important;
                      "
                    >
                      Billing Address is required and cannot be left blank
                    </div>
                    <div class="row mb-2 pr-0 mt-2">
                      <div class="col-sm-5 pr-0">
                        <input
                          type="text"
                          id="city"
                          [(ngModel)]="city"
                          (ngModelChange)="validate()"
                          class="form-control"
                          placeholder="City"
                        />
                      </div>
                      <div class="col-sm-4 select-font16">
                        <ng-select
                          [items]="statesArr"
                          placeholder="Select"
                          [searchable]="false"
                          [clearable]="false"
                          name="selectedstate"
                          [(ngModel)]="state"
                          (change)="getState(state)"
                          #selectedstate="ngModel"
                        >
                        </ng-select>
                      </div>
                      <div class="col-sm-3 pl-0">
                        <input
                          type="tel"
                          numbersOnly
                          [(ngModel)]="zipcode"
                          (ngModelChange)="validate()"
                          class="form-control"
                          maxlength="5"
                          placeholder="Zip"
                          id="zipcode"
                        />
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="cityisNull === true"
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          City is required and cannot be left blank
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes('BillingCity')
                        "
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">Please enter a valid City</div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="
                          zipInvalidLength ||
                          (postResponseMessage &&
                            postResponseMessage.includes('Zipcode'))
                        "
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Please enter a 5-digit Zip Code
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="zipcodeisNull"
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Zipcode is required and cannot be left blank
                        </div>
                      </div>
                      <!-- <div
                        class="ml-3"
                        *ngIf="postResponseMessage === 'cardError'"
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          We are unable to process your payment. Please verify
                          your deposit details and try again.
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mt-2 px-0">
                      <label class="font19-weight-semibold-calibre"
                        >Description</label
                      >
                    </div>
                    <br />
                    <div class="col-sm-12 d-flex px-0">
                      <div class="col-sm-10 pl-0 mb-2">
                        <input
                          type="text"
                          id="description"
                          [(ngModel)]="description"
                          class="form-control"
                          placeholder="Description"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 px-0" *ngIf="!autoPay4CE && isChecked">
                  <div class="row font19-weight-semibold-calibre">
                    For AutoPay Purposes - Enter Card Number*
                  </div>
                  <div class="row">
                    <div
                      class="custom-control custom-checkbox chkbox mb-0"
                      style="
                        padding-left: 15px;
                        margin-bottom: 0px !important;
                        margin-top: 0 !important;
                        border: none;
                      "
                    >
                      <input
                        type="checkbox"
                        id="autoPayOption"
                        name="autoPayOption"
                        class="custom-control-input"
                        [(ngModel)]="autoPayment"
                        (click)="autoPayOptionClick($event)"
                      />
                      <label
                        class="custom-control-label font16 ml-2"
                        style="
                          padding-left: 10px;
                          color: black !important;
                          font-weight: normal !important;
                        "
                        for="autoPayOption"
                        >Use same payment information as provided above</label
                      >
                    </div>
                  </div>
                  <div *ngIf="!autoPayment">
                    <div
                      class="card-wrapper-auto-pay"
                      data-jp-card-initialized="true"
                    >
                      <div class="jp-card-container">
                        <div class="jp-card" id="auto-card-details">
                          <div class="jp-card-front">
                            <div class="jp-card-logo jp-card-elo">
                              <div class="e">e</div>
                              <div class="l">l</div>
                              <div class="o">o</div>
                            </div>
                            <div id="visa" class="jp-card-logo jp-card-visa">
                              Visa
                            </div>
                            <div class="jp-card-logo jp-card-visaelectron">
                              Visa
                              <div class="elec">Electron</div>
                            </div>
                            <div class="jp-card-logo jp-card-mastercard">
                              Mastercard
                            </div>
                            <div class="jp-card-logo jp-card-maestro">
                              Maestro
                            </div>
                            <div class="jp-card-logo jp-card-amex"></div>
                            <div class="jp-card-logo jp-card-discover">
                              discover
                            </div>
                            <div class="jp-card-logo jp-card-unionpay">
                              UnionPay
                            </div>
                            <div class="jp-card-logo jp-card-dinersclub"></div>
                            <div class="jp-card-logo jp-card-hipercard">
                              Hipercard
                            </div>
                            <div class="jp-card-logo jp-card-troy">troy</div>
                            <div class="jp-card-logo jp-card-dankort">
                              <div class="dk">
                                <div class="d"></div>
                                <div class="k"></div>
                              </div>
                            </div>
                            <div class="jp-card-logo jp-card-jcb">
                              <div class="j">J</div>
                              <div class="c">C</div>
                              <div class="b">B</div>
                            </div>
                            <div class="jp-card-lower">
                              <div class="jp-card-shiny"></div>
                              <div class="jp-card-cvc jp-card-display">•••</div>
                              <div class="jp-card-number jp-card-display">
                                {{ validateCardDisplay('noauto') }}
                              </div>
                              <div class="jp-card-name jp-card-display">
                                {{ validateFullName('noauto') }}
                              </div>
                              <div
                                class="jp-card-expiry jp-card-display"
                                data-before="mm/yy"
                                data-after="validdate"
                              >
                                {{ automonth }}/{{ autoyear }}
                              </div>
                            </div>
                          </div>
                          <div class="jp-card-back">
                            <div class="jp-card-bar"></div>
                            <div class="jp-card-cvc jp-card-display">
                              {{ validateSecurityCode('noauto') }}
                            </div>
                            <div class="jp-card-shiny"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />

                    <div class="row">
                      <div class="col-md-7 px-0" id="cdNum">
                        <input
                          class="form-control"
                          type="text"
                          id="txtAutoCardNumber"
                          placeholder="Credit Card Number"
                          [maxlength]="maxLength"
                          (change)="validateAutoCreditCardNumber()"
                          (keyup)="onChangeAutoTxtCardNumber($event)"
                          (keypress)="numberOnly($event)"
                          [(ngModel)]="formattedAutoCardNumber"
                        />
                      </div>
                      <div class="col-md-5">
                        <img
                          style="width: 130px; height: auto !important"
                          class="mt-1"
                          src="/assets/images/cc-cards-images1.png"
                        />
                      </div>

                      <div
                        *ngIf="validCard && formattedAutoCardNumber.length > 10"
                        class="col-sm-12 px-0"
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          That card number did not work. Try again using Visa,
                          MasterCard, Discover or American Express
                        </div>
                      </div>
                      <div
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes(
                            'DepositCreditCard Number'
                          )
                        "
                        class="col-sm-12 px-0"
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          That card number did not work. Please try re-entering
                          it
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-5 px-0">
                        <div class="col-sm-12 px-0 mt-2">
                          <label class="font19-weight-semibold-calibre"
                            >Expiration Date*</label
                          >
                        </div>
                        <div class="col-md-12 d-flex px-0">
                          <div class="mm-yy mr-3">
                            <ng-select
                              [items]="monthList"
                              bindLabel="Text"
                              bindValue="Value"
                              placeholder="MM"
                              [searchable]="true"
                              [clearable]="false"
                              id="cautomonth"
                              name="automonth"
                              [(ngModel)]="automonth"
                              (change)="validateAutoMonth()"
                              style="width: 110px"
                            >
                            </ng-select>
                          </div>
                          <div class="mm-yy">
                            <ng-select
                              [items]="yearsList"
                              bindLabel="Text"
                              bindValue="Value"
                              placeholder="YYYY"
                              [searchable]="true"
                              [clearable]="false"
                              name="autoyear"
                              id="cautoyear"
                              [(ngModel)]="autoyear"
                              (change)="validateAutoYear()"
                              style="width: 110px"
                            >
                            </ng-select>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-4 px-0">
                        <div class="col-sm-12 mt-2 pr-0">
                          <label class="font19-weight-semibold-calibre"
                            >Security Code*</label
                          >
                        </div>
                        <div class="col-sm-11" style="padding-left: 75px">
                          <input
                            class="form-control"
                            numbersOnly
                            [(ngModel)]="autosecuiritycode"
                            type="text"
                            (change)="validateAutoCvv($event, 'noauto')"
                            (keyup)="
                              flipCardForSecurityCode(
                                $event.target.value,
                                'noauto'
                              )
                            "
                            id="autoccode"
                            name="autosecuiritycode"
                            placeholder="CVV"
                            maxlength="4"
                            size="4"
                            required="true"
                            style="width: 64px; height: 38px"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="ml-3"
                          *ngIf="blankmontherr"
                          style="
                            font-size: 14px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            Please provide the Expiration Month (MM)
                          </div>
                        </div>
                        <div
                          class="ml-3"
                          *ngIf="blankyearerr"
                          style="
                            font-size: 14px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            Please provide the Expiration Year (YYYY)
                          </div>
                        </div>
                        <div
                          class="ml-3"
                          *ngIf="showAutoMmontherr || autoYearErrorFlag"
                          style="
                            font-size: 14px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            {{ errorMessage }}
                          </div>
                        </div>
                        <div
                          *ngIf="
                            postResponseMessage &&
                            (postResponseMessage.includes(
                              'DepositCreditCardYear'
                            ) ||
                              postResponseMessage.includes(
                                'DepositCreditCardMonth'
                              ))
                          "
                          class="ml-3"
                          style="
                            font-size: 14px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            {{ errorMessage }}
                          </div>
                        </div>
                        <div
                          class="ml-3"
                          *ngIf="cvvAutoValid"
                          style="
                            font-size: 14px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            Security code is invalid. Please verify and try
                            again.
                          </div>
                        </div>
                        <div
                          class="ml-3"
                          *ngIf="
                            postResponseMessage &&
                            postResponseMessage.includes(
                              'DepositCreditCard CVV/CID'
                            )
                          "
                          style="
                            font-size: 14px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            Security code is invalid. Please verify and try
                            again.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 mt-2 px-0">
                        <label class="font19-weight-semibold-calibre"
                          >Name as it appears on card*</label
                        >
                      </div>
                      <div class="col-sm-10 pl-0">
                        <input
                          type="text"
                          IsAlphaNumeric
                          class="form-control"
                          (change)="validateccAutoName($event)"
                          (keyup)="flipCardFront('noauto')"
                          [(ngModel)]="autocardName"
                          id="autocardname"
                          name="autocardname"
                          placeholder="First and last name"
                          required="true"
                          style="
                            width: 325px !important;
                            height: 38px !important;
                          "
                        />
                      </div>
                      <div
                        class="col-sm-12 px-0"
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes(
                            'Required Deposit card billing Info'
                          )
                        "
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Required information is missing. Please verify your
                          details and try again.
                        </div>
                      </div>
                      <div
                        class="col-sm-12 px-0"
                        *ngIf="checkAutoCardName"
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Please provide your First and Last Name
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 mt-2 px-0">
                        <label class="font19-weight-semibold-calibre"
                          >Billing Address*</label
                        >
                      </div>
                      <br />
                      <div class="col-sm-12 d-flex px-0">
                        <div class="col-sm-10 pl-0 mb-2">
                          <input
                            type="text"
                            id="autostreet_address"
                            [(ngModel)]="autostreet_address"
                            class="form-control"
                            (ngModelChange)="validate()"
                            placeholder="Street Address"
                          />
                        </div>
                        <div class="col-sm-2 mb-2 px-0">
                          <div>
                            <input
                              type="text"
                              id="autoapt"
                              [(ngModel)]="autoapt"
                              class="form-control"
                              (ngModelChange)="validate()"
                              placeholder="Apt"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-md-12 px-0 alertMsg"
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes(
                            'BillingAddress has reached its character limit'
                          )
                        "
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                          margin-top: -3px !important;
                        "
                      >
                        Please enter a valid Billing Address
                      </div>
                      <div
                        class="col-md-12 px-0 alertMsg"
                        *ngIf="autostreet_addressisNull"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                          margin-top: -3px !important;
                        "
                      >
                        Billing Address is required and cannot be left blank
                      </div>
                      <div class="row mb-2 pr-0 mt-2">
                        <div class="col-sm-5 pr-0">
                          <input
                            type="text"
                            id="autocity"
                            [(ngModel)]="autocity"
                            (ngModelChange)="validate()"
                            class="form-control"
                            placeholder="City"
                          />
                        </div>
                        <div class="col-sm-4 select-font16">
                          <ng-select
                            [items]="statesArr"
                            placeholder="Select"
                            [searchable]="false"
                            [clearable]="false"
                            name="autoselectedstate"
                            [(ngModel)]="autostate"
                            (change)="getState(state)"
                            #selectedstate="ngModel"
                          >
                          </ng-select>
                        </div>
                        <div class="col-sm-3 pl-0">
                          <input
                            type="tel"
                            numbersOnly
                            [(ngModel)]="autozipcode"
                            (ngModelChange)="validate()"
                            class="form-control"
                            maxlength="5"
                            placeholder="Zip"
                            id="autozipcode"
                          />
                        </div>
                        <div
                          class="ml-3"
                          *ngIf="autocityisNull"
                          style="
                            font-size: 16px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            City is required and cannot be left blank
                          </div>
                        </div>
                        <div
                          class="ml-3"
                          *ngIf="
                            postResponseMessage &&
                            postResponseMessage.includes('BillingCity')
                          "
                          style="
                            font-size: 16px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">Please enter a valid City</div>
                        </div>
                        <div
                          class="ml-3"
                          *ngIf="
                            autozipInvalidLength ||
                            (postResponseMessage &&
                              postResponseMessage.includes('Zipcode'))
                          "
                          style="
                            font-size: 16px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            Please enter a 5-digit Zip Code
                          </div>
                        </div>
                        <div
                          class="ml-3"
                          *ngIf="autozipcodeisNull"
                          style="
                            font-size: 16px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            Zipcode is required and cannot be left blank
                          </div>
                        </div>

                        <div
                          class="ml-3"
                          *ngIf="
                            postResponseMessage &&
                            postResponseMessage.includes(
                              'Unable to process your payment'
                            )
                          "
                          style="
                            font-size: 16px !important;
                            color: #ed1976 !important;
                          "
                        >
                          <div class="alertMsg">
                            We are unable to process your payment. Please verify
                            your credit card details and try again.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 mt-2 px-0">
                        <label class="font19-weight-semibold-calibre"
                          >Description</label
                        >
                      </div>
                      <br />
                      <div class="col-sm-12 d-flex px-0">
                        <div class="col-sm-10 pl-0 mb-2">
                          <input
                            type="text"
                            id="autodescription"
                            [(ngModel)]="autodescription"
                            class="form-control"
                            placeholder="Description"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row ng-tns-c2-0 ng-star-inserted">
                <div class="row mt-2">
                  <div class="row" *ngIf="isChecked">
                    <div
                      class="custom-control custom-checkbox chkbox mb-0"
                      style="
                        margin-bottom: 0px !important;
                        margin-top: 0 !important;
                        border: none;
                      "
                    >
                      <input
                        type="checkbox"
                        id="EZPay"
                        class="custom-control-input"
                        [(ngModel)]="EZPay"
                      />
                      <label
                        class="custom-control-label font16 ml-2"
                        style="
                          cursor: pointer !important;
                          line-height: 100%;
                          font-size: 19px !important;
                          font-weight: normal;
                          color: black !important;
                        "
                        for="EZPay"
                        >I agree to the
                        <a
                          href="https://www.4changeenergy.com/Docs/4Change-EZPay-Terms-Conditions.pdf"
                          target="_blank"
                          >EZ Pay terms and conditions</a
                        >
                        and consent to receive a copy of those terms
                        electronically.</label
                      >
                    </div>
                  </div>
                  <div *ngIf="!autoPay4CE && isChecked" class="row">
                    <div
                      class="custom-control custom-checkbox chkbox mb-0"
                      style="
                        margin-bottom: 0px !important;
                        margin-top: 0 !important;
                        border: none;
                      "
                    >
                      <input
                        type="checkbox"
                        id="acceptNoAutoPay"
                        class="custom-control-input"
                        [(ngModel)]="acceptNoAutoPay"
                      />
                      <label
                        class="custom-control-label font16 ml-2"
                        style="
                          cursor: pointer !important;
                          line-height: 100%;
                          font-size: 19px !important;
                          font-weight: normal;
                          color: black !important;
                        "
                        for="acceptNoAutoPay"
                        >I authorize 4Change Energy to charge me the above
                        mentioned amount of ${{ depositAmount4CE }} with the
                        payment account information provided. I understand that
                        this is required to complete the setup of establishing
                        service with 4Change Energy.</label
                      >
                    </div>
                  </div>
                  <div class="row" *ngIf="isChecked">
                    <div
                      class="custom-control custom-checkbox chkbox mb-0"
                      style="
                        margin-bottom: 0px !important;
                        margin-top: 0 !important;
                        border: none;
                      "
                    >
                      <input
                        type="checkbox"
                        id="acceptAutoPay"
                        class="custom-control-input"
                        [(ngModel)]="acceptAutoPay"
                      />
                      <label
                        class="custom-control-label font16 ml-2"
                        style="
                          cursor: pointer !important;
                          line-height: 100%;
                          font-size: 19px !important;
                          font-weight: normal;
                          color: black !important;
                        "
                        for="acceptAutoPay"
                        >I authorize 4Change Energy to setup my account for
                        autopay and debit from my financial institution each
                        month the total bill amount for electricity service with
                        the payment account information provided above. I
                        understand that this is required to complete the setup
                        of establishing service with 4Change Energy.</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-sm-12 text-center ng-tns-c2-0 ng-star-inserted my-3"
            >
              <button
                id="enrollment-payment-form-submit-button"
                class="btn sectbtn mt-2 m-auto"
                style="
                  width: auto !important;
                  padding-left: 25px;
                  font-size: 18px !important;
                  padding-right: 25px;
                "
                [ngClass]="{ sectbtn: user_bot, disabledButton: !user_bot }"
                (click)="sendApiDetails()"
                [disabled]="isDisable"
              >
                <i class="fa fa-lock mr-1" aria-hidden="true"></i
                >{{ depositNowWithPayAndAutoPay }}
              </button>
            </div>
            <div *ngIf="creditCardErrorResponse() !== undefined">
              <div
                class="m-auto col-md-10 blockbg boxclr text-center mt-3 py-4 px-3"
                style="vertical-align: middle; line-height: 1"
              >
                <p class="text-center tipmes mb-0">
                  {{ creditCardErrorResponse() }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row-fluid mobileview mt-4 pt-4">
        <div class="d-flex h-100 row pr-0">
          <div
            class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
          >
            <img
              style="width: 100% !important"
              src="assets/images/signimg.jpg"
            />
          </div>
          <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box mr-3" [@flyOut]="'in'">
              <h1 *ngIf="autoPay4CE" class="questionMob text-left">
                It looks like setting up autopay is required to sign up for this
                plan.
              </h1>
              <h1 *ngIf="!autoPay4CE" class="questionMob text-left">
                It looks like a deposit and autopay are required to sign up for
                this plan.
              </h1>
            </div>
          </div>
        </div>
        <h1
          *ngIf="autoPay4CE"
          class="text-center"
          style="font-size: 19px; font-family: Calibre-semiBold"
        >
          {{ setMobileDepositTitleValue() }}
        </h1>
        <div class="d-flex h-100 row pr-0 mt-2">
          <div class="col-sm-3 col-2 pl-0"></div>
          <div *ngIf="autoPay4CE" class="col-sm-9 col-9 pl-0 pr-4">
            <span class="ssnTxt d-inline-block mt-2"
              >Due to your credit and as a favor so that you don’t miss a
              payment and have to deal with annoying late fees and possible
              disconnect / reconnect fees etc, 4Change Energy is asking that you
              signup for autopay in order to proceed signing up for this plan.
            </span>
          </div>
          <div *ngIf="!autoPay4CE" class="col-sm-9 col-9 pl-0 pr-4">
            <span class="ssnTxt d-inline-block mt-2"
              >Due to your credit and as a favor so that you don’t miss a
              payment and have to deal with annoying late fees and possible
              disconnect / reconnect fees etc, 4Change Energy is asking that you
              post a ${{ depositAmount4CE }} deposit and signup for autopay in
              order to proceed signing up for this plan.
            </span>

            <span class="ssnTxt d-inline-block mt-2"
              >To not miss out on this offer and get your service request
              processed today, please click the button below.
            </span>

            <span class="ssnTxt d-inline-block mt-2"
              ><strong
                style="
                  font-size: 19px !important;
                  font-family: 'Calibre-SemiBold';
                "
                >Important Note:</strong
              >
              If you choose to pay the deposit, it will be returned to you with
              interest either after one year as a customer-in-good-standing with
              4Change Energy, or if you move-out of your location before your
              contract expires. Please see your Terms of Service for 4Change
              Energy’s Deposit Policy.
            </span>
          </div>
          <div
            class="col-sm-12 m-auto text-left mr-4"
            style="width: 95% !important"
          >
            <label
              class="custom-control custom-checkbox chkbox mb-2 box-shadow"
              for="payfordepositt"
              style=" border: 1px solid #ed1976;"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="payfordepositt"
                value="payDeposit"
                name="payfordepositt"
                (click)="onChangeRole($event)"
              />
              <label
                class="custom-control-label font20 ml-2"
                for="payfordepositt"
                style="
                  color: black !important;
                  font-weight: normal;
                 
                "
                >{{ setDepositLabelValue() }}</label
              >
            </label>
            <label
              class="custom-control custom-checkbox chkbox mb-2 box-shadow"
              for="applyAnotherProviderMob"
              style="border: 1px solid #ed1976;"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="applyAnotherProviderMob"
                value="Applyforadepositwaiver"
                name="applyAnotherProviderMob"
                (click)="onChangeApplyAnotherProvider($event)"
              />
              <label
                class="custom-control-label font20 ml-2"
                style="
                  color: black !important;
                  font-weight: normal;
                  text-align:left;
                  line-height: 1.2;
                "
                for="applyAnotherProviderMob"
                >Get started with prepaid electricity 
                for just $19.99. No deposit required</label
              >
            </label>
          </div>
          <div
            class="col-sm-8 offset-sm-2 ng-tns-c2-0 ng-star-inserted"
            *ngIf="isChecked"
            style="width: 95%; padding-left: 27px"
          >
            <div class="col-sm-12 px-0">
              <label class="mb-0 font-weight-semibold-calibre">{{
                setCardTextAutoPayBased()
              }}</label>
            </div>
            <div class="row">
              <div class="pl-3">
                <input
                  class="form-control"
                  type="text"
                  id="cardNumber"
                  name="txtCardNumber"
                  placeholder="Credit Card Number"
                  [maxlength]="maxLength"
                  (change)="validateCreditCardNumber('auto')"
                  (keyup)="onChangeTxtCardNumber($event)"
                  (keypress)="numberOnly($event)"
                  [(ngModel)]="formattedCardNumber"
                  style="width: 220px !important; height: 38px !important"
                />
              </div>
              <div class="pl-2 mt-1">
                <img
                  style="width: 130px; height: auto !important"
                  src="/assets/images/cc-cards-images1.png"
                />
              </div>

              <div
                *ngIf="validCard"
                class="col-sm-6"
                style="font-size: 16px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  That card number did not work. Try again using Visa,
                  MasterCard, Discover or American Express
                </div>
              </div>
              <div
                *ngIf="
                  postResponseMessage &&
                  postResponseMessage.includes('DepositCreditCard Number')
                "
                class="col-sm-6"
                style="font-size: 16px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  That card number did not work. Please try re-entering it
                </div>
              </div>
            </div>
            <div class="row d-flex">
              <div class="px-0 mt-2">
                <div class="pl-3 mt-2">
                  <label class="mb-0 font-weight-semibold-calibre"
                    >Expiration Date*</label
                  >
                </div>
                <div class="row d-flex px-3">
                  <div class="pl-3 pr-0">
                    <ng-select
                      [items]="monthList"
                      bindLabel="Text"
                      bindValue="Value"
                      placeholder="MM"
                      [searchable]="true"
                      [clearable]="false"
                      id="ccmonth"
                      name="month"
                      [(ngModel)]="month"
                      (change)="validateMonth()"
                      style="width: 110px"
                    >
                    </ng-select>
                  </div>
                  <div class="px-0" style="padding-left: 10px !important">
                    <ng-select
                      [items]="yearsList"
                      bindLabel="Text"
                      bindValue="Value"
                      placeholder="YYYY"
                      [searchable]="true"
                      [clearable]="false"
                      name="year"
                      id="ccyear"
                      [(ngModel)]="year"
                      (change)="validateYear()"
                      style="width: 110px"
                    >
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="ml-4 mt-2 px-4">
                <div class="row mt-2">
                  <label class="mb-0 font-weight-semibold-calibre"
                    >Security Code*</label
                  >
                </div>
                <div class="row">
                  <input
                    class="form-control"
                    [(ngModel)]="secuiritycode"
                    (change)="validatecvv($event, 'auto')"
                    id="cccode"
                    type="text"
                    style="width: 62px; height: 36px"
                    name="secuiritycode"
                    placeholder="CVV"
                    maxlength="4"
                    size="4"
                    required="true"
                  />
                </div>
              </div>

              <div
                class="ml-3"
                *ngIf="blankmontherr"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Please provide the Expiration Month (MM)
                </div>
              </div>
              <div
                class="ml-3"
                *ngIf="blankyearerr"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Please provide the Expiration Year (YYYY)
                </div>
              </div>

              <div
                class="ml-3"
                *ngIf="showmontherr"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Date occurs in the past. Enter a future date
                </div>
              </div>
              <div
                *ngIf="
                  postResponseMessage &&
                  (postResponseMessage.includes('DepositCreditCardYear') ||
                    postResponseMessage.includes('DepositCreditCardMonth'))
                "
                class="ml-3"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Date occurs in the past. Enter a future date
                </div>
              </div>

              <div
                class="ml-3"
                *ngIf="cvvValid"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Security code is invalid. Please verify and try again.
                </div>
              </div>
              <div
                class="ml-3"
                *ngIf="
                  postResponseMessage &&
                  postResponseMessage.includes('DepositCreditCard CVV/CID')
                "
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Security code is invalid. Please verify and try again.
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-2">
                <label class="mb-0 font-weight-semibold-calibre mt-1"
                  >Name as it appears on card*</label
                >
              </div>
              <div class="col-sm-9">
                <input
                  class="form-control"
                  type="text"
                  IsAlphaNumeric
                  [(ngModel)]="cardName"
                  id="carddname"
                  name="cardname"
                  (change)="validateccName($event)"
                  placeholder="First and last name"
                  required="true"
                />
              </div>
              <div
                class="ml-3"
                *ngIf="checkCardName"
                style="font-size: 16px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Please provide your First and Last Name
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-2">
                <label class="mb-0 font-weight-semibold-calibre mt-1"
                  >Billing Address*</label
                >
              </div>
              <br />
              <div class="col-sm-12 px-0">
                <div class="col-sm-12 col-12 mb-2">
                  <input
                    type="text"
                    id="street_address"
                    [(ngModel)]="street_address"
                    class="form-control"
                    (ngModelChange)="validate()"
                    placeholder="Street Address"
                  />
                  <div
                    class="col-md-12 px-0 mb-1 alertMsg"
                    *ngIf="
                      postResponseMessage &&
                      postResponseMessage.includes(
                        'BillingAddress has reached its character limit'
                      )
                    "
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    Please enter a valid Billing Address
                  </div>
                  <div
                    class="col-md-12 px-0 mb-1 alertMsg"
                    *ngIf="street_addressisNull"
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    Billing Address is required and cannot be left blank
                  </div>
                </div>

                <div class="col-sm-3 col-4 mb-2">
                  <input
                    type="text"
                    id="apt"
                    [(ngModel)]="apt"
                    class="form-control"
                    (ngModelChange)="validate()"
                    placeholder="Apt"
                  />
                </div>
              </div>
              <div class="row col-sm-9 col-12 mb-2 pr-0">
                <div class="col-sm-4 col-6 pr-0">
                  <input
                    type="text"
                    [(ngModel)]="city"
                    (ngModelChange)="validate()"
                    class="form-control"
                    placeholder="City"
                  />
                </div>
                <div class="col-sm-3 col-3 pr-0 select-font16">
                  <ng-select
                    [items]="statesArr"
                    placeholder="Select"
                    [searchable]="true"
                    [clearable]="false"
                    name="selectedstate"
                    [(ngModel)]="state"
                    (change)="getState(state)"
                    #selectedstate="ngModel"
                  >
                  </ng-select>
                </div>
                <div class="col-sm-5 col-3 pr-0">
                  <input
                    type="tel"
                    numbersOnly
                    [(ngModel)]="zipcode"
                    (ngModelChange)="validate()"
                    class="form-control"
                    maxlength="5"
                    placeholder="Zip"
                  />
                </div>

                <div
                  class="ml-3"
                  *ngIf="cityisNull === true"
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">
                    City is required and cannot be left blank
                  </div>
                </div>
                <div
                  class="ml-3"
                  *ngIf="
                    postResponseMessage &&
                    postResponseMessage.includes('BillingCity')
                  "
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">Please enter a valid City</div>
                </div>
                <div
                  class="ml-3"
                  *ngIf="
                    zipInvalidLength ||
                    (postResponseMessage &&
                      postResponseMessage.includes('Zipcode'))
                  "
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">Please enter a 5-digit Zip Code</div>
                </div>
                <div
                  class="ml-3"
                  *ngIf="zipcodeisNull"
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">
                    Zipcode is required and cannot be left blank
                  </div>
                </div>

                <div
                  class="ml-3"
                  *ngIf="
                    postResponseMessage &&
                    postResponseMessage.includes(
                      'Unable to process your payment'
                    )
                  "
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">
                    We are unable to process your payment. Please verify your
                    deposit details and try again.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-2">
                <label class="mb-0 font-weight-semibold-calibre mt-1"
                  >Description</label
                >
              </div>
              <br />
              <div class="col-sm-12 px-0">
                <div class="col-sm-12 col-12 mb-2">
                  <input
                    type="text"
                    id="street_address"
                    [(ngModel)]="description"
                    class="form-control"
                    (ngModelChange)="validate()"
                    placeholder="Description"
                  />
                </div>
              </div>
            </div>
            <div
              class="row mt-2"
              style="padding-left: 16px"
              *ngIf="!autoPay4CE"
            >
              <div class="col-sm-12 px-0">
                <label class="mb-0 font-weight-semibold-calibre"
                  >For Autopay Purposes - Enter Card Number*</label
                >
              </div>
              <div class="row">
                <div
                  class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                  style="
                    margin-bottom: 0px !important;
                    border: none;
                    box-shadow: none !important;
                  "
                >
                  <input
                    type="checkbox"
                    id="autoPayOption"
                    class="custom-control-input"
                    name="autoPayOption"
                    [(ngModel)]="autoPayment"
                    (click)="autoPayOptionClick($event)"
                  />
                  <label
                    style="
                      cursor: pointer !important;
                      line-height: 100%;
                      font-size: 15px !important;
                      color: black;
                      font-weight: normal;
                    "
                    class="custom-control-label mt-1"
                    for="autoPayOption"
                    >Use same payment information as provided above.</label
                  >
                </div>
                <!-- </div> -->
              </div>

              <div *ngIf="!autoPayment">
                <div class="row">
                  <div class="pl-3">
                    <input
                      class="form-control"
                      type="text"
                      id="txtAutoCardNumber"
                      name="txtAutoCardNumber"
                      placeholder="Credit Card Number"
                      [maxlength]="maxLength"
                      (change)="validateAutoCreditCardNumber()"
                      (keyup)="onChangeAutoTxtCardNumber($event)"
                      (keypress)="numberOnly($event)"
                      [(ngModel)]="formattedAutoCardNumber"
                      style="width: 220px !important; height: 38px !important"
                    />
                  </div>
                  <div class="pl-2 mt-1">
                    <img
                      style="width: 130px; height: auto !important"
                      src="/assets/images/cc-cards-images1.png"
                    />
                  </div>

                  <div
                    *ngIf="validCard"
                    class="col-sm-6"
                    style="
                      font-size: 16px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      That card number did not work. Try again using Visa,
                      MasterCard, Discover or American Express
                    </div>
                  </div>
                  <div
                    *ngIf="
                      postResponseMessage &&
                      postResponseMessage.includes('DepositCreditCard Number')
                    "
                    class="col-sm-6"
                    style="
                      font-size: 16px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      That card number did not work. Please try re-entering it
                    </div>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="px-0 mt-2">
                    <div class="pl-3 mt-2">
                      <label class="mb-0 font-weight-semibold-calibre"
                        >Expiration Date*</label
                      >
                    </div>
                    <div class="row d-flex px-3">
                      <div class="pl-3 pr-0">
                        <ng-select
                          [items]="monthList"
                          bindLabel="Text"
                          bindValue="Value"
                          placeholder="MM"
                          [searchable]="true"
                          [clearable]="false"
                          id="ccmonth"
                          name="automonth"
                          [(ngModel)]="automonth"
                          (change)="validateMonth()"
                          style="width: 110px"
                        >
                        </ng-select>
                      </div>
                      <div class="px-0" style="padding-left: 10px !important">
                        <ng-select
                          [items]="yearsList"
                          bindLabel="Text"
                          bindValue="Value"
                          placeholder="YYYY"
                          [searchable]="true"
                          [clearable]="false"
                          name="autoyear"
                          id="ccautoyear"
                          [(ngModel)]="autoyear"
                          (change)="validateAutoYear()"
                          style="width: 110px"
                        >
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="ml-4 mt-2 px-4">
                    <div class="row mt-2">
                      <label class="mb-0 font-weight-semibold-calibre"
                        >Security Code*</label
                      >
                    </div>
                    <div class="row">
                      <input
                        class="form-control"
                        numbersOnly
                        [(ngModel)]="autosecuiritycode"
                        (change)="validateAutoCvv($event, 'noauto')"
                        id="cccode"
                        type="text"
                        style="width: 62px; height: 36px"
                        name="secuiritycode"
                        placeholder="CVV"
                        maxlength="4"
                        size="4"
                        required="true"
                      />
                    </div>
                  </div>

                  <div
                    class="ml-3"
                    *ngIf="blankmontherr"
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      Please provide the Expiration Month (MM)
                    </div>
                  </div>
                  <div
                    class="ml-3"
                    *ngIf="blankyearerr"
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      Please provide the Expiration Year (YYYY)
                    </div>
                  </div>

                  <div
                    class="ml-3"
                    *ngIf="showmontherr"
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      Date occurs in the past. Enter a future date
                    </div>
                  </div>
                  <div
                    *ngIf="
                      postResponseMessage &&
                      (postResponseMessage.includes('DepositCreditCardYear') ||
                        postResponseMessage.includes('DepositCreditCardMonth'))
                    "
                    class="ml-3"
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      Date occurs in the past. Enter a future date
                    </div>
                  </div>

                  <div
                    class="ml-3"
                    *ngIf="cvvAutoValid"
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      Security code is invalid. Please verify and try again.
                    </div>
                  </div>
                  <div
                    class="ml-3"
                    *ngIf="
                      postResponseMessage &&
                      postResponseMessage.includes('DepositCreditCard CVV/CID')
                    "
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      Security code is invalid. Please verify and try again.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 mt-2">
                    <label class="mb-0 font-weight-semibold-calibre mt-1"
                      >Name as it appears on card*</label
                    >
                  </div>
                  <div class="col-sm-9">
                    <input
                      class="form-control"
                      type="text"
                      IsAlphaNumeric
                      [(ngModel)]="autocardName"
                      id="autocardname"
                      name="autocardname"
                      placeholder="First and last name"
                      (change)="validateccAutoName($event)"
                      required="true"
                    />
                  </div>
                  <div
                    class="ml-3"
                    *ngIf="checkAutoCardName"
                    style="
                      font-size: 16px !important;
                      color: #ed1976 !important;
                    "
                  >
                    <div class="alertMsg">
                      Please provide your First and Last Name
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 mt-2">
                    <label class="mb-0 font-weight-semibold-calibre mt-1"
                      >Billing Address*</label
                    >
                  </div>
                  <br />
                  <div class="col-sm-12 px-0">
                    <div class="col-sm-12 col-12 mb-2">
                      <input
                        type="text"
                        id="autostreet_address"
                        [(ngModel)]="autostreet_address"
                        class="form-control"
                        (ngModelChange)="validate()"
                        placeholder="Street Address"
                      />
                      <div
                        class="col-md-12 px-0 mb-1 alertMsg"
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes(
                            'BillingAddress has reached its character limit'
                          )
                        "
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        Please enter a valid Billing Address
                      </div>
                      <div
                        class="col-md-12 px-0 mb-1 alertMsg"
                        *ngIf="autostreet_addressisNull"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        Billing Address is required and cannot be left blank
                      </div>
                    </div>

                    <div class="col-sm-3 col-4 mb-2">
                      <input
                        type="text"
                        id="autoapt"
                        [(ngModel)]="autoapt"
                        class="form-control"
                        (ngModelChange)="validate()"
                        placeholder="Apt"
                      />
                    </div>
                  </div>
                  <div class="row col-sm-9 col-12 mb-2 pr-0">
                    <div class="col-sm-4 col-6 pr-0">
                      <input
                        type="text"
                        id="autocity"
                        [(ngModel)]="autocity"
                        (ngModelChange)="validate()"
                        class="form-control"
                        placeholder="City"
                      />
                    </div>
                    <div class="col-sm-3 col-3 pr-0 select-font16">
                      <ng-select
                        [items]="statesArr"
                        placeholder="Select"
                        [searchable]="true"
                        [clearable]="false"
                        name="autoselectedstate"
                        [(ngModel)]="autostate"
                        (change)="getState(state)"
                        #selectedstate="ngModel"
                      >
                      </ng-select>
                    </div>
                    <div class="col-sm-5 col-3 pr-0">
                      <input
                        type="tel"
                        numbersOnly
                        [(ngModel)]="autozipcode"
                        (ngModelChange)="validate()"
                        class="form-control"
                        maxlength="5"
                        placeholder="Zip"
                        id="autozipcode"
                      />
                    </div>

                    <div
                      class="ml-3"
                      *ngIf="autocityisNull"
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        City is required and cannot be left blank
                      </div>
                    </div>
                    <div
                      class="ml-3"
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes('BillingCity')
                      "
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">Please enter a valid City</div>
                    </div>
                    <div
                      class="ml-3"
                      *ngIf="
                        autozipInvalidLength ||
                        (postResponseMessage &&
                          postResponseMessage.includes('Zipcode'))
                      "
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        Please enter a 5-digit Zip Code
                      </div>
                    </div>
                    <div
                      class="ml-3"
                      *ngIf="autozipcodeisNull"
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        Zipcode is required and cannot be left blank
                      </div>
                    </div>

                    <div
                      class="ml-3"
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes(
                          'Unable to process your payment'
                        )
                      "
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        We are unable to process your payment. Please verify
                        your deposit details and try again.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 mt-2">
                    <label class="mb-0 font-weight-semibold-calibre mt-1"
                      >Description</label
                    >
                  </div>
                  <br />
                  <div class="col-sm-12 px-0">
                    <div class="col-sm-12 col-12 mb-2">
                      <input
                        type="text"
                        id="autodescription"
                        [(ngModel)]="autodescription"
                        class="form-control"
                        (ngModelChange)="validate()"
                        placeholder="Description"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-9 pl-0">
                <div
                  class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                  style="
                    margin-bottom: 0px !important;
                    border: none;
                    box-shadow: none !important;
                  "
                >
                  <input
                    type="checkbox"
                    id="EZPay"
                    class="custom-control-input"
                    [(ngModel)]="EZPay"
                  />
                  <label
                    style="
                      cursor: pointer !important;
                      line-height: 100%;
                      font-size: 15px !important;
                      color: black;
                      font-weight: normal;
                    "
                    class="custom-control-label mt-1"
                    for="EZPay"
                    >I agree to the
                    <a
                      href="https://www.4changeenergy.com/Docs/4Change-EZPay-Terms-Conditions.pdf"
                      target="_blank"
                      >EZ Pay terms and conditions</a
                    >
                    and consent to receive a copy of those terms
                    electronically.</label
                  >
                </div>
                <div
                  class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                  style="
                    margin-bottom: 0px !important;
                    border: none;
                    box-shadow: none !important;
                  "
                >
                  <input
                    type="checkbox"
                    id="acceptAutoPay"
                    class="custom-control-input"
                    [(ngModel)]="acceptAutoPay"
                  />
                  <label
                    style="
                      cursor: pointer !important;
                      line-height: 100%;
                      font-size: 15px !important;
                      color: black;
                      font-weight: normal;
                    "
                    class="custom-control-label mt-1"
                    for="acceptAutoPay"
                    >I authorize 4Change Energy to charge me the above mentioned
                    amount of ${{ depositAmount4CE }} with the payment account
                    information provided. I understand that this is required to
                    complete the setup of establishing service with 4Change
                    Energy.</label
                  >
                </div>
                <div
                  *ngIf="!autoPay4CE"
                  class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                  style="
                    margin-bottom: 0px !important;
                    border: none;
                    box-shadow: none !important;
                  "
                >
                  <input
                    type="checkbox"
                    id="acceptNoAutoPay"
                    class="custom-control-input"
                    [(ngModel)]="acceptNoAutoPay"
                  />
                  <label
                    style="
                      cursor: pointer !important;
                      line-height: 100%;
                      font-size: 15px !important;
                      color: black;
                      font-weight: normal;
                    "
                    class="custom-control-label mt-1"
                    for="acceptNoAutoPay"
                    >I authorize 4Change Energy to setup my account for autopay
                    and debit from my financial institution each month the total
                    bill amount for electricity service with the payment account
                    information provided above. I understand that this is
                    required to complete the setup of establishing service with
                    4Change Energy.</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center">
            <button
              id="enrollment-payment-form-submit-button"
              class="btn sectbtn my-2"
              style="
                width: auto !important;
                padding-left: 25px;
                font-size: 18px !important;
                padding-right: 25px;
              "
              [ngClass]="{ sectbtn: user_bot, disabledButton: !user_bot }"
              (click)="sendApiDetails()"
              [disabled]="isDisable"
            >
              <i class="fa fa-lock mr-1" aria-hidden="true"></i
              >{{ depositNowWithPayAndAutoPay }}
            </button>
          </div>
        </div>

        <div id="thankAns">
          <div
            class="d-flex h-100 row pr-0 mt-3"
            *ngIf="
              isChecked &&
              ansinSSncheck1 == 'Thank you, goodbye' &&
              timeTrue == true
            "
          >
            <div
              class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
            >
              <img
                style="width: 100% !important"
                src="assets/images/signimg.jpg"
              />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
              <div
                class="arrow_box mr-3"
                [@flyOutans]="'in'"
                *ngIf="isChecked && ansinSSncheck1 == 'Thank you, goodbye'"
              >
                <h1 class="questionMob">
                  Got it, but before you leave, if you have any questions why
                  your enrollment request did not go through and want to speak
                  to someone about it, you may contact
                  <span class="font-weight-bold p-1">{{
                    selectedProduct.energy_provider
                  }}</span>
                  <span class="mb-1"
                    >{{
                      providerContact != undefined &&
                      providerContact.working_hours
                        ? providerContact.working_hours
                        : ''
                    }} </span
                  ><br />
                  <span class="fntbold clrblue"
                    ><a
                      [href]="'tel:' + providerContact.customerDeposit_enquiry"
                      style="color: #1f0bcc !important"
                      >{{
                        providerContact != undefined &&
                        providerContact.customerDeposit_enquiry
                          ? providerContact.customerDeposit_enquiry
                          : ''
                      }}.</a
                    ></span
                  >
                  <span>
                    Be sure to mention Honest Gorilla, when you speak with a
                    {{ providerContact.provider_name }} representative.</span
                  >
                </h1>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-12 px-0"
            id="thankAns1"
            *ngIf="
              isChecked &&
              ansinSSncheck1 == 'Thank you, goodbye' &&
              timeTrue == true
            "
          >
            <label
              class="custom-control custom-checkbox chkbox mb-2 pr-0 box-shadow"
              for="thankyou"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="thankyou"
                value="Thank you"
                name="thankyou"
                [(ngModel)]="ssndepostList.value8"
                (click)="onChangeRole($event)"
              />
              <label class="custom-control-label font20" for="thankyou"
                >Thank you</label
              >
            </label>
          </div>
        </div>

        <div id="speaksomeone">
          <div
            class="d-flex h-100 row pr-0 mt-3"
            *ngIf="
              isChecked &&
              ansinSSncheck1 == 'I would like to speak with someone' &&
              timeTrue == true
            "
          >
            <div
              class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
            >
              <img
                style="width: 100% !important"
                src="assets/images/signimg.jpg"
              />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
              <div
                class="arrow_box mr-3"
                [@flyOutans]="'in'"
                *ngIf="
                  isChecked &&
                  ansinSSncheck1 == 'I would like to speak with someone'
                "
              >
                <h1 class="questionMob">
                  To learn more details why your enrollment request did not go
                  through, please contact
                  <span class="font-weight-bold p-1">{{
                    selectedProduct.energy_provider
                  }}</span>
                  <span class="mb-1"
                    >{{
                      providerContact != undefined &&
                      providerContact.working_hours
                        ? providerContact.working_hours
                        : ''
                    }}
                  </span>
                  <span class="fntbold clrblue"
                    ><a
                      [href]="'tel:' + providerContact.customerDeposit_enquiry"
                      style="
                        cursor: pointer !important;
                        color: #1f0bcc !important;
                      "
                      >{{
                        providerContact != undefined &&
                        providerContact.customerDeposit_enquiry
                          ? providerContact.customerDeposit_enquiry
                          : ''
                      }}.</a
                    ></span
                  ><br />
                  <span>
                    Be sure to mention Honest Gorilla, when you speak with a
                    {{ providerContact.provider_name }} representative.</span
                  >
                </h1>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-12 px-0"
            id="thankAns1"
            *ngIf="
              isChecked &&
              ansinSSncheck1 == 'I would like to speak with someone' &&
              timeTrue == true
            "
          >
            <label
              class="custom-control custom-checkbox chkbox mb-2 pr-0 box-shadow"
              for="thankyou"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="thankyou"
                value="Thank you"
                name="thankyou"
                [(ngModel)]="ssndepostList.value8"
                (click)="onChangeRole($event)"
              />
              <label class="custom-control-label font20" for="thankyou"
                >Thank you</label
              >
            </label>
          </div>
        </div>

        <div class="col-sm-9 col-9 ml-auto mt-4 px-0">
          <div class="col-12" style="width: 100% !important; text-align: right">
            <div
              id="secondAns_id"
              class="mb-3 ash_box text-right"
              [@flyOutans]="'in'"
              *ngIf="ansinSSncheck2 == 'Goodbye'"
            >
              <h1 class="ansMob text-right">{{ ansinSSncheck2 }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<p class="m-0 text-muted tapmsg" style="color: #0055ff !important">
  <a
    href="javascript:void(0)"
    id="openModalButtonForAction"
    (click)="openModal(template)"
  >
  </a>
</p>

<ng-template #template>
  <div>
    <div class="modal-dialog" role="document">
      <div class="modal-content zind1 boxRadius">
        <div class="modal-body">
          <button
            type="button"
            class="close videoclose"
            id="closeModelAlign"
            data-dismiss="modal"
            aria-label="Close"
            (click)="hideModal()"
          >
            <div class="float-right mr-2">
              <img src="assets/images/editchart-close.svg" width="20" />
            </div>
          </button>

          <div class="service-modal px-sm-4">
            <div class="modal-border">
              <h1
                class="text-left conthead font-weight-bold-calibre mt-4 pt-2 mb-2"
                style="font-size: 20px !important"
              >
                Help is on the way
              </h1>
              <span style="clear: left"></span>
            </div>
            <div class="bdy-section pt-0">
              <div>
                <p class="mt-2">
                  You can contact
                  <span class="font-weight-bold">{{
                    selectedProduct.energy_provider
                  }}</span>
                  <span class="mb-1 px-1">{{
                    providerContact != undefined &&
                    providerContact.working_hours
                      ? providerContact.working_hours
                      : ''
                  }}</span>
                  <br /><span class="fntbold clrblue"
                    ><a
                      [href]="'tel:' + providerContact.customerDeposit_enquiry"
                      style="color: #1f0bcc !important"
                      >{{
                        providerContact != undefined &&
                        providerContact.customerDeposit_enquiry
                          ? providerContact.customerDeposit_enquiry
                          : ''
                      }}</a
                    ></span
                  >
                </p>

                <p class="mb-4">
                  If you are receiving this message outside of business hours,
                  then feel free to leave a Voicemail at the number provided
                  above and someone will respond to you at their earliest
                  convenience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #errorStatus4CE>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="closeEnrollmentStatusTemplate()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img
              src="assets/images/editchart-close.svg"
              width="17"
              style="margin-top: -10px"
            />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        Uh-oh! An Error Has Occurred
      </h4>
      <p class="utility-sub-title font20">
        While processing your information, it seems that something did not go as
        planned.
      </p>
      <br />
      <p class="utility-sub-title font20">
        To save the headache of trying to figure it out, it will be quickest for
        you to call {{ selectedProduct.energy_provider }} and speak to one of
        their customer care specialists.
      </p>
      <br />
      <p class="utility-sub-title font20">
        Click or call
        <a
          [href]="customerEnrollmentHotlineLink()"
          style="color: blue !important"
        >
          {{ customerEnrollmentHotline() }}</a
        >
        for immediate assistance and to finish signing up. We apologize for the
        inconvenience.
      </p>
      <div class="col-12 text-center webview">
        <button
          id="enrollment-payment-form-submit-button"
          class="btn sectbtn my-2 text-uppercase"
          style="
            width: auto !important;
            padding-left: 25px;
            font-size: 18px !important;
            padding-right: 25px;
          "
          (click)="closeEnrollmentStatusTemplate()"
        >
          Thank You
        </button>
      </div>
    </div>
  </div>
</ng-template>

<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait a few seconds while your payment info is being processed
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
